import AutoForm from '@/components/AutoForm'
export default {
  components: {
    AutoForm
  },
  data(){
    let validateComname = (rule, value, callback) => {
      var self = this;
      let formEdit = self.formList.filter((item)=>item.form.State == null || item.form.State == 9);
      self.$http.post(self.url.VerifyCustomCompanyName, {
        Data: {
          CompanyName:value,
          CompanyId:formEdit[0].form.Id
        }
      }).then(result => {
        if(!result){
          callback(new Error('企业名称已存在，换一个吧~'));
        }else{
          callback();
        }
      }, () => {

      });
    }
    // 银行卡号
    let validateBankcard2 = (rule, value, callback) => {
      if(!this.formChange.Account) {
        callback();
        // }
        // else if (!this.bankIsOk) {
        //   callback(new Error('您输入的银行卡号暂不支持！'));
      } else {
        validateBankcard(rule, value, callback);
      }
    }

    // 营业执照
    let validateBusinessLicense = (rule, value, callback) => {
      var reg = /(^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$)|(^\d{15}$)/;
      if(!this.formChange.BusinessLicense) {
        callback();
      }
      else if (!reg.test(value)) {
        callback(new Error('您输入正确的营业执照！'));
      } else {
        callback();
      }
    }

    // 法人
    let validateJuridicalPerson = (rule, value, callback) => {
      if(!this.formChange.JuridicalPerson) {
        callback();
      }
      else if (value.length > 5) {
        callback(new Error('长度不能超过 5 个字符'));
      } else {
        callback();
      }
    }

    // 税号
    let validateDutyParagraph = (rule, value, callback) => {
      var reg = /^[A-Z0-9]{15}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/;
      if(!this.formChange.DutyParagraph) {
        callback();
      }
      else if (!reg.test(value)) {
        callback(new Error('您输入正确的税号！'));
      } else {
        callback();
      }
    }

    // 电话
    let validatePhone2 = (rule, value, callback) => {
      var reg = /^((0\d{2,3}-\d{7,8})|(1[3567849]\d{9}))$/;
      if(!this.formChange.Phone) {
        callback();
      }
      else if (!reg.test(value)) {
        callback(new Error('您输入号码格式不正确或者位数不正确！'));
      } else {
        callback();
      }
      /*else {
        validatePhone(rule, value, callback);
      }*/
    }
    // 传真
    let validateFax= (rule, value, callback) => {
      if(!this.formChange.Fax) {
        callback();
      }
      else if (value.length > 20) {
        callback(new Error('长度不能超过 20 个字符'));
      } else {
        callback();
      }
    }
    // 邮编
    let validateZipCode= (rule, value, callback) => {
      if(!this.formChange.ZipCode) {
        callback();
      }
      else if (value.length > 50) {
        callback(new Error('长度不能超过 50 个字符'));
      } else {
        callback();
      }
    }
    // 证件号码格式验证
    let validateConfirmIdCard = (rule, value, callback) => {
      if(!this.formChange.ContactCardId) {
        callback();
      }
      switch (this.form.ContactCardType) {
        case 0: //
          validateIdCard(rule, value, callback);
          break;
        case 1:
          validatePassport(rule, value, callback);
          break;
        case 2:
          validateMilitaryCard(rule, value, callback);
          break;
        case 9:
          validateHMPassCard(rule, value, callback);
          break;
      }
    };
    // 联系人邮箱验证
    let validateContactsEmail = (rule, value, callback) => {
      var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if(!this.formChange.ContactsEmail) {
        callback();
      }
      else if (!reg.test(value)) {
        callback(new Error('您输入邮箱格式不正确！'));
      } else {
        callback();
      }
    };
    return{

      formList:[
        {
          form: {
            Name:'',SimpleName:'',EnglishName:'',Code:'',BusinessLicense:'',DutyParagraph:'',Adress:'',JuridicalPerson:'',Phone:'',Fax:'',ZipCode:'',
            Account: '',Bank: null ,AccountBank:null,State:null,Id:'',
            Province: null ,City: null ,
            ContactsName:'',ContactsEmail:'',
            ContactCardId:'',
            ContactCardType:0,
            OnlyBusinessLicense:'',BusinessLicenseTime:'',AccountBankTime:'',
            BusinessLicensePic:[],BankPic:[]
          },
        }
      ],

      formPersonal:{
        // ContactsName:'',
        // ContactCardNumber:'',
        // ContactsEmail:'',
        // AccountHolderName:'',
        // Account:'', Bank:'', Province:'',City:'',AccountBank: null,
        // ObversePicLst:[],ReversePicLst:[]
      },
      rules: {
        Name :[
          { required: true, message: '请输入企业名称', trigger: 'blur' },
          {  max: 200, message: '长度不能超过 200 个字符', trigger: 'blur' },
          {
            validator: validateComname,
            trigger: 'blur'
          }
        ],
        SimpleName :[
          { required: true, message: '请输入企业简称', trigger: 'blur' },
          {  max: 50, message: '长度不能超过 50 个字符', trigger: 'blur' }
        ],
        EnglishName :[
          {  max: 500, message: '长度不能超过 500 个字符', trigger: 'blur' }
        ],
        Code :[
          {  max: 50, message: '长度不能超过 50 个字符', trigger: 'blur' }
        ],
        Adress: [
          { required: true, message: '请输入开票地址', trigger: 'blur' }
        ],
        BusinessLicense :[
          { required: true, message: '请输入营业执照', trigger: 'blur' },
          {
            validator: validateBusinessLicense,
            trigger: 'blur'
          }
        ],
        // JuridicalPerson:[
        //   { required: true, message: '请输入法人', trigger: 'blur' },
        //   {
        //     validator: validateJuridicalPerson,
        //     trigger: 'blur'
        //   }
        // ],
        DutyParagraph:[
          { required: true, message: '请输入税号', trigger: 'blur' },
          {
            validator: validateDutyParagraph,
            trigger: 'blur'
          }
        ],
        OnlyBusinessLicense :[
          { required: true, message: '请选择三证合一', trigger: 'change' }
        ],
        Phone :[
          // {
          //   required: true,
          //   message: '请输入电话',
          //   trigger: 'blur'
          // },
          {
            validator: validatePhone2,
            trigger: 'blur'
          }
        ],
        Fax :[
          {
            validator: validateFax,
            trigger: 'blur'
          }
        ],
        ZipCode :[
          {
            validator: validateZipCode,
            trigger: 'blur'
          }
        ],
        Area:[
          {  max: 10, message: '长度不能超过 10 个字符', trigger: 'blur' }
        ],
        Account:[
          {
            required: true,
            message: '请输入银行账号',
            trigger: 'blur'
          },
          {
            validator: validateBankcard2,
            trigger: 'blur'
          }
        ],
        Bank: [{ required: true, message: '请选择开户行', trigger: 'change' }],
        Province: [{ required: true, message: '请选择开票所在省份', trigger: 'change' }],
        City: [{ required: true, message: '请选择开票所在城市', trigger: 'change' }],
        AccountBank: [{ required: true, message: '请选择开户银行支行', trigger: 'change' }],
        // ContactsName:[
        //   { required: true, message: '请输入联系人姓名', trigger: 'blur' }
        // ],
        // ContactCardId:[
        //   {
        //     required: true,
        //     message: '请输入证件号码',
        //     trigger: 'blur'
        //   },
        //   {
        //     validator: validateConfirmIdCard,
        //     trigger: 'blur'
        //   }
        // ],
        // ContactsPhone:[
        //   {
        //     required: true,
        //     message: '请输入联系人手机',
        //     trigger: 'blur'
        //   },
        //   {
        //     validator: validatePhone2,
        //     trigger: 'blur'
        //   }
        // ],
        // ContactsEmail:[
        //   {
        //     validator: validateContactsEmail,
        //     trigger: 'blur'
        //   }
        // ],
        BusinessLicensePic:[
          {
            required: true,
            message: '请上传营业执照',
            trigger: 'blur'
          },
        ],
        BusinessLicenseTime:[
          {
            required: true,
            message: '请输入营业执照有效期',
            trigger: 'blur'
          },
        ],
        AccountBankTime:[
          {
            required: true,
            message: '请输入银行开户许可证有效期',
            trigger: 'blur'
          },
        ],
        BankPic:[
          {
            required: true,
            message: '请上传银行开户许可证照',
            trigger: 'blur'
          },
        ]
      },

      formTemplatenew:[
        {
          formTpl:[
            { col:24, type: 'tips', tips:'企业基本信息' },
            { col:24, label:'企业名称', prop:'Name' },
            { col:12, label:'企业简称', prop:'SimpleName' },
            { col:12, label:'英文名称', prop:'EnglishName' },
            { col: 12, label: '省份', prop: 'Province', type: 'select', options: [], change: () => { this.loadCity(); }, filterable: true, default: '' }, // 24
            { col: 12, label: '地级市', prop: 'City', type: 'select', options: [],filterable: true, default: '' }, // 25
            { col:24, label:'开票地址', prop:'Adress' },
            { col:12, label:'法人', prop:'JuridicalPerson' },
            { col:12, label:'手机号',prop:'Phone',change:(v)=>{this.PhoneChange(v)} },
            { col:12, label:'传真', prop:'Fax',change:(v)=>{this.FaxChange(v)} },
            { col:12, label:'邮编', prop:'ZipCode',change:(v)=>{this.ZipCodeChange(v)} },

            { col:24, type: 'tips', tips:'企业银行信息' },
            { col: 24, label: '银行账号', prop: 'Account', change: (v) => { this.onAccountChange(v); }, default: '' }, // 26
            { col: 24, label: '开户银行', prop: 'Bank', type: 'select', change: () => { this.loadBankBranch(); }, options: [], filterable: true, default: '' }, // 23
            // { col: 12, label: '开户省份', prop: 'Province', type: 'select', options: [], change: () => { this.loadCity(); }, filterable: true, default: '' }, // 24
            // { col: 12, label: '开户地级市', prop: 'City', type: 'select', options: [], change: () => { this.loadBankBranch(); }, filterable: true, default: '' }, // 25
            { col: 24, label: '开户银行支行', prop: 'AccountBank', type: 'select', options: [], filterable: true, default: '' }, // 26



            { col:24, type: 'tips', tips:'企业附件' }, // 31
            { col:24, label:'三证合一', prop:'OnlyBusinessLicense', type: 'radio',
              options: [
                { label: '是', value: true },
                { label: '否', value: false }
              ],
              default: true
            },
            { col:24, label:'营业执照号', prop:'BusinessLicense', change:(v)=>{this.BusinessLicenseChange(v)} },
            { col:24, label:'税务登记证编号', prop:'DutyParagraph' ,change:(v)=>{this.DutyParagraphChange(v)}, showByProp: 'OnlyBusinessLicense', showValue: false },
            { col:24, label:'组织机构代码', prop:'OrgCode' ,change:(v)=>{this.DutyParagraphChange(v)}, showByProp: 'OnlyBusinessLicense', showValue: false },
            { col:12, label:'营业执照有效期', type: 'date', prop:'BusinessLicenseTime' },
            { col:12, label:'开户许可有效期', type: 'date', prop:'AccountBankTime' },
            { col:12, label:'营业执照', prop:'BusinessLicensePic', type:'picture-list', default:[], formIdProp: 'Id', pictureType: 'Enterprise', limit: 1 },
            { col:12, label:'银行开户许可证照片', prop:'BankPic', type:'picture-list', default:[], formIdProp: 'Id', pictureType: 'Enterprise', limit: 1 },
          ]
        }
      ],
      url: {
        province: SZH.assets.api + "/Market/GetSelectProvince",
        city: SZH.assets.api + "/Market/GetSelectCity",
        bank: SZH.assets.api + "/Market/GetSelectBaseBank",
        bankBranch: SZH.assets.api + "/Market/GetSelectBankInfo",
        bankSearch: SZH.assets.api + "/Market/GetBankMapping",

        get: SZH.assets.api + '/Custom/GetCompanyListInfo',
        get2: SZH.assets.api + '/Custom/GetCustomRealNameInfo',
        save: SZH.assets.api + '/Custom/SaveCustomEnterpriseNew',
        getCode: SZH.assets.api + '/Authen/GetCustomSAPNo',
        saveCommon:SZH.assets.api + '/Custom/SaveCustomRealName',
        VerifyCustomCompanyName:SZH.assets.api + '/Authen/VerifyCustomCompanyName',
      },
      formChange: {
        Account:false, // 银行卡号
        BusinessLicense: false, // 营业执照
        JuridicalPerson:false, // 法人
        DutyParagraph:false, // 税号
        Phone:false, // 电话
        Fax:false, // 传真
        ZipCode:false, // 邮编
        ContactsEmail:false, // 联系人邮箱
      },
      state: [],
      isEdit:true,
      uploading:false,
      loading:false,
      boxLoading:false,
      types: '',
    //  Add by guoxinhui3.30
      activeNames: [0],
      whichCom:0, //
    }
  },
  methods:{

    //Add by guoxinhui 3\30
    companyName(index){
      let indexadd = ++index;
      return "企业-"+indexadd
    },

    formatDate(datetime) {
      return new Date(datetime).format('yyyy-MM-dd');
    },

    submitForm(formName) {
      let self = this;
      var json = localStorage.getItem('formBasic');
      var objS = JSON.parse(json);
      if(objS != null){
        for(let i=0;i<this.formList.length;i++){
          self.formList[i].form.ContactsName = objS.ContactsName;
          self.formList[i].form.ContactsEmail = objS.ContactsEmail;
          self.formList[i].form.ContactCardId = objS.ContactCardNumber;
        }
      }


      let indexForm = 0;//用来记录第几个form

      let newArr = []; //用来存储promise返回的结果
      //参数的格式
      let arr = [];
      let obj = {};
      for(var i= 0;i<self.formList.length;i++){
        if(self.formList[i].form.State == null || self.formList[i].form.State == 9){
          arr.push(self.formList[i].form);//只有是可编辑状态的数据才能够提交保存
        }

      }

      if(self.types == 4){
        let Ptjson = localStorage.getItem('ordinaryForm');
        let Ptobj = JSON.parse(Ptjson);
        if(arr.length == 0){
          self.boxLoading = true;
          self.$http.post(self.url.saveCommon, { Data:Ptobj}).then(result => {
            if (result.State == 1) {
              self.$message.success(result.Message);
              self.boxLoading = false;
              this.$router.push({
                path: '/My/Info'
              })
            } else {
              self.$message.error(result.Message);
              self.boxLoading = false;
            }

          }, () => {
          });
        }else{
          self.$http.post(self.url.saveCommon, { Data:Ptobj}).then(result => {
            if (result.State == 1) {

            } else {

            }

          }, () => {
          });
          obj.Companies = arr;

          this.formList.forEach((item,index)=>{
            indexForm = index; //因为多个form用的ref相同所以通过下标来分辨不同form
            checkForm('form',item)

          });
          Promise.all(newArr).then((result) => {
            self.boxLoading = true;
            self.$http.post(self.url.save, { Data:obj}).then(result => {
              if (result.State == 1) {
                self.$message.success(result.Message);
                self.boxLoading = false;
                this.$router.push({
                  path: '/My/Info'
                })
              } else {
                self.$message.error(result.Message);
                self.boxLoading = false;
              }

            }, () => {
            });

          }).catch((error) => {

            self.$message.error('填写的企业信息有误，请仔细检查、认真填写');

          });

        }

      }else{
        // 若果可编辑的form数量为0不让提交
        if(arr.length == 0){
          self.$message.error('当前企业状态不可编辑，无法提交！');
        }else{

          obj.Companies = arr;
          this.formList.forEach((item,index)=>{
            indexForm = index; //因为多个form用的ref相同所以通过下标来分辨不同form
            checkForm('form',item)

          });
          Promise.all(newArr).then((result) => {
            self.boxLoading = true;
            self.$http.post(self.url.save, { Data:obj}).then(result => {
              if (result.State == 1) {
                self.$message.success(result.Message);
                self.boxLoading = false;
                this.$router.push({
                  path: '/My/Info'
                })
              } else {
                self.$message.error(result.Message);
                self.boxLoading = false;
              }

            }, () => {
            });

          }).catch((error) => {

            self.$message.error('填写的企业信息有误，请仔细检查、认真填写');

          });
        }
      }

      //根据form表单的ref，动态生成promise，再对其坐表单校验，都通过了再去做处理
      function checkForm(arrName,item) {

        if(item.form.State == null || item.form.State == 9){
          var result = new Promise(function(resolve, reject) {
            self.$refs[arrName][indexForm].validate((valid) => {
              if (valid) {
                resolve();
              } else { reject() }
            })
          });
          newArr.push(result) //push 得到promise的结果
        }
      }


    },
    addCompany(){
      //存在可编辑的企业不让继续添加
      console.log(this.formList)
      let arr = this.formList.filter(item=>item.form.State == 9 || item.form.State == null);
      //存在审批中状态的企业不让继续添加
      let arrApproval = this.formList.filter(item=>item.form.State == 0 || item.form.State == 1);
      if(arr && arr.length>0){
        this.$message.error('有可编辑的企业信息，无法继续新增企业');
        return
      }
      if(arrApproval && arrApproval.length>0){
        this.$message.error('有审批中状态的企业，无法继续新增企业');
        return
      }
      this.formList.push(
        {
          form: {
            Name:'',SimpleName:'',EnglishName:'',Code:'',BusinessLicense:'',DutyParagraph:'',Adress:'',JuridicalPerson:'',Phone:'',Fax:'',ZipCode:'',
            Account: '',Bank: null ,AccountBank:null,State:null,Id:'',
            Province: null ,City: null ,
            ContactsName:'',ContactsEmail:'',
            ContactCardId:'',
            ContactCardType:0,
            OnlyBusinessLicense:'',BusinessLicenseTime:'',AccountBankTime:'',
            BusinessLicensePic:[],BankPic:[]
          },
        }
      );
      this.formTemplatenew.push(
        {
          formTpl:[
            { col:24, type: 'tips', tips:'企业基本信息' },
            { col:24, label:'企业名称', prop:'Name' },
            { col:12, label:'企业简称', prop:'SimpleName' },
            { col:12, label:'英文名称', prop:'EnglishName' },
            { col: 12, label: '省份', prop: 'Province', type: 'select', options: [], change: () => { this.loadCity(); }, filterable: true, default: '' }, // 24
            { col: 12, label: '地级市', prop: 'City', type: 'select', options: [], filterable: true, default: '' }, // 25
            { col:24, label:'开票地址', prop:'Adress' },
            { col:12, label:'法人', prop:'JuridicalPerson' },
            { col:12, label:'手机号',prop:'Phone',change:(v)=>{this.PhoneChange(v)} },
            { col:12, label:'传真', prop:'Fax',change:(v)=>{this.FaxChange(v)} },
            { col:12, label:'邮编', prop:'ZipCode',change:(v)=>{this.ZipCodeChange(v)} },
            { col:24, type: 'tips', tips:'企业银行信息' },
            { col: 24, label: '银行账号', prop: 'Account', change: (v) => { this.onAccountChange(v); }, default: '' }, // 26
            { col: 24, label: '开户银行', prop: 'Bank', type: 'select', options: [],change: () => { this.loadBankBranch(); }, filterable: true, default: '' }, // 23
            // { col: 12, label: '开户省份', prop: 'Province', type: 'select', options: [], change: () => { this.loadCity(); }, filterable: true, default: '' }, // 24
            // { col: 12, label: '开户地级市', prop: 'City', type: 'select', options: [], change: () => { this.loadBankBranch(); }, filterable: true, default: '' }, // 25
            { col: 24, label: '开户银行支行', prop: 'AccountBank', type: 'select', options: [], filterable: true, default: '' }, // 26

            { col:24, type: 'tips', tips:'企业附件' }, // 31
            { col:24, label:'三证合一', prop:'OnlyBusinessLicense', type: 'radio',
              options: [
                { label: '是', value: true },
                { label: '否', value: false }
              ],
              default: true
            },
            { col:24, label:'营业执照号', prop:'BusinessLicense', change:(v)=>{this.BusinessLicenseChange(v)} },
            { col:24, label:'税务登记证编号', prop:'DutyParagraph' ,change:(v)=>{this.DutyParagraphChange(v)}, showByProp: 'OnlyBusinessLicense', showValue: false },
            { col:24, label:'组织机构代码', prop:'OrgCode' ,change:(v)=>{this.DutyParagraphChange(v)}, showByProp: 'OnlyBusinessLicense', showValue: false },
            { col:12, label:'营业执照有效期', type: 'date', prop:'BusinessLicenseTime' },
            { col:12, label:'开户许可有效期', type: 'date', prop:'AccountBankTime' },
            { col:12, label:'营业执照', prop:'BusinessLicensePic', type:'picture-list', default:[], formIdProp: 'Id', pictureType: 'Enterprise', limit: 1 },
            { col:12, label:'银行开户许可证照片', prop:'BankPic', type:'picture-list', default:[], formIdProp: 'Id', pictureType: 'Enterprise', limit: 1 },
          ]
        }
      )
    },

    //上一步
    getUp(){
      if (this.types == 2) {
        this.$router.push({
          path: '/My/PerfectInformation',
          query:{
            types: 2
          }
        })
      } else if(this.types == 4){
        this.$router.push({
          path: '/My/UserInfo',
          query:{
            types: 3
          }
        })
      }
    },
    selectChange(v){
      this.form.ContactCardId = null
    },

    beforeSave() {
      this.uploading = true;
    },
    afterSaved() {
      this.uploading = false;
    },
    onSaved() {
      this.$message.success("保存成功");
      this.$router.push({
        path: '/My/Info'
      })
      //this.loadData();
      /*this.visible = false;
      this.$emit('saved');*/
    },

    loadData() {
      let self = this;
      self.boxLoading = true;
      for(var i in this.formChange){
        this.formChange[i] = false;
      }
      self.$http.post(self.url.get, {
      }).then(result => {

        if (result.State == 1 && result.Data) {

          for(let j =0;j<result.Data.length-1;j++){
            self.formList.push(
              {
                form: {
                  Name:'',SimpleName:'',EnglishName:'',Code:'',BusinessLicense:'',DutyParagraph:'',Adress:'',JuridicalPerson:'',Phone:'',Fax:'',ZipCode:'',
                  Account: '',Bank: null ,AccountBank:null,State:null,Id:'',
                  Province: null ,City: null ,
                  ContactsName:'',ContactsEmail:'',
                  ContactCardId:'',
                  ContactCardType:0,
                  OnlyBusinessLicense:'',BusinessLicenseTime:'',AccountBankTime:'',
                  BusinessLicensePic:[],BankPic:[]
                },
              }
            )

            self.formTemplatenew.push(
              {
                formTpl:[
                  { col:24, type: 'tips', tips:'企业基本信息' },
                  { col:24, label:'企业名称', prop:'Name' },
                  { col:12, label:'企业简称', prop:'SimpleName' },
                  { col:12, label:'英文名称', prop:'EnglishName' },
                  { col: 12, label: '省份', prop: 'Province', type: 'select', options: [], change: () => { this.loadCity(); }, filterable: true, default: '' }, // 24
                  { col: 12, label: '地级市', prop: 'City', type: 'select', options: [], filterable: true, default: '' }, // 25
                  { col:24, label:'开票地址', prop:'Adress' },
                  { col:12, label:'法人', prop:'JuridicalPerson' },
                  { col:12, label:'手机号',prop:'Phone',change:(v)=>{this.PhoneChange(v)} },
                  { col:12, label:'传真', prop:'Fax',change:(v)=>{this.FaxChange(v)} },
                  { col:12, label:'邮编', prop:'ZipCode',change:(v)=>{this.ZipCodeChange(v)} },
                  { col:24, type: 'tips', tips:'企业银行信息' },
                  { col: 24, label: '银行账号', prop: 'Account', change: (v) => { this.onAccountChange(v); }, default: '' }, // 26
                  { col: 24, label: '开户银行', prop: 'Bank', type: 'select', options: [],change: () => { this.loadBankBranch(); }, filterable: true, default: '' }, // 23
                  // { col: 12, label: '开户省份', prop: 'Province', type: 'select', options: [], change: () => { this.loadCity(); }, filterable: true, default: '' }, // 24
                  // { col: 12, label: '开户地级市', prop: 'City', type: 'select', options: [], change: () => { this.loadBankBranch(); }, filterable: true, default: '' }, // 25
                  { col: 24, label: '开户银行支行', prop: 'AccountBank', type: 'select', options: [], filterable: true, default: '' }, // 26

                  { col:24, type: 'tips', tips:'企业附件' }, // 31
                  { col:24, label:'三证合一', prop:'OnlyBusinessLicense', type: 'radio',
                    options: [
                      { label: '是', value: true },
                      { label: '否', value: false }
                    ],
                    default: true
                  },
                  { col:24, label:'营业执照号', prop:'BusinessLicense', change:(v)=>{this.BusinessLicenseChange(v)} },
                  { col:24, label:'税务登记证编号', prop:'DutyParagraph' ,change:(v)=>{this.DutyParagraphChange(v)}, showByProp: 'OnlyBusinessLicense', showValue: false },
                  { col:24, label:'组织机构代码', prop:'OrgCode' ,change:(v)=>{this.DutyParagraphChange(v)}, showByProp: 'OnlyBusinessLicense', showValue: false },
                  { col:12, label:'营业执照有效期', type: 'date', prop:'BusinessLicenseTime' },
                  { col:12, label:'开户许可有效期', type: 'date', prop:'AccountBankTime' },
                  { col:12, label:'营业执照', prop:'BusinessLicensePic', type:'picture-list', default:[], formIdProp: 'Id', pictureType: 'Enterprise', limit: 1 },
                  { col:12, label:'银行开户许可证照片', prop:'BankPic', type:'picture-list', default:[], formIdProp: 'Id', pictureType: 'Enterprise', limit: 1 },
                ]
              }
            )
          }
          self.formList.forEach((item,index)=>{
            for(let i in item.form){
              item.form[i] = result.Data[index][i];
            }
            self.loadCitynew(index);
            self.$nextTick(() => {
              item.form.City = result.Data[index].City;
              self.loadBankBranchnew(index);
              item.form.Account = result.Data[index].Account;
              item.form.AccountBank = result.Data[index].AccountBank;
            })

          })

        } else {
          // for(var i in self.form) {
          //   self.form[i] = null
          // }
        }
        self.boxLoading = false;
      }, () => { });
    },
    loadProvince() {
      let index = this.whichCom;
      var self = this;
      self.$http.post(self.url.province, {}).then(result => {
        for (let i in self.formTemplatenew[index].formTpl){
          if(self.formTemplatenew[index].formTpl[i].prop == 'Province'){
            if (result.State == 1 && result.Data != null){
              self.formTemplatenew[index].formTpl[i].options = result.Data;
            }else{
              self.formTemplatenew[index].formTpl[i].options = [];
            }
          }
        }
      }, () => {
      });
    },
    //
    handleChange(index){
      this.whichCom = index;
      this.loadProvince();//这个必须要触发一下，因为在添加多个form的时候不触发省数据使用不了
      this.loadBanks();
    },
    goBack() {
      localStorage.removeItem('formBasic');
      this.$router.push({
        path: '/My/Info'
      })
    },
    loadCity() {
      let index = this.whichCom;
      var self = this;
      self.formList[index].form.City = '';
      self.$http.post(self.url.city, { Data: self.formList[index].form.Province }).then(result => {
        for (let i in self.formTemplatenew[index].formTpl){
          if(self.formTemplatenew[index].formTpl[i].prop == 'City'){
            if (result.State == 1 && result.Data != null){
              self.formTemplatenew[index].formTpl[i].options = result.Data;
            }else{
              self.formTemplatenew[index].formTpl[i].options = [];
            }
          }
        }
      }, () => {
      });
    },
    loadCitynew(index) {
      var self = this;
      self.formList[index].form.City = '';
      self.$http.post(self.url.city, { Data: self.formList[index].form.Province }).then(result => {
        for (let i in self.formTemplatenew[index].formTpl){
          if(self.formTemplatenew[index].formTpl[i].prop == 'City'){
            if (result.State == 1 && result.Data != null){
              self.formTemplatenew[index].formTpl[i].options = result.Data;
            }else{
              self.formTemplatenew[index].formTpl[i].options = [];
            }
          }
        }
      }, () => {
      });
    },
    loadBanks() {
      let index = this.whichCom;
      var self = this;
      self.$http.post(self.url.bank, { Data: self.formList[index].form.Province }).then(result => {
        for(var i in self.formTemplatenew[index].formTpl){
          if(self.formTemplatenew[index].formTpl[i].prop == 'Bank'){
            if (result.State == 1 && result.Data != null){
              self.formTemplatenew[index].formTpl[i].options = result.Data;
            }else{
              self.formTemplatenew[index].formTpl[i].options = [];
            }
          }
        }
      }, () => {
      });
    },
    loadBankBranch() {
      let index = this.whichCom;
      var self = this;
      if (self.formList[index].form.City != '' && self.formList[index].form.City != null && self.formList[index].form.Bank != '' && self.formList[index].form.Bank != null) {
        self.formList[index].form.AccountBank = null
        self.$http.post(self.url.bankBranch, {
          Data: {
            BankId: self.formList[index].form.Bank,
            CityId: self.formList[index].form.City,
          }
        }).then(result => {
          for(var i in self.formTemplatenew[index].formTpl){
            if(self.formTemplatenew[index].formTpl[i].prop == 'AccountBank'){
              if (result.State == 1 && result.Data != null){
                self.formTemplatenew[index].formTpl[i].options = result.Data;
              }else{
                self.formTemplatenew[index].formTpl[i].options = [];
              }
            }
          }
        }, () => {
        });
      }
    },

    loadBankBranchnew(index) {
      let indexNum = index;
      var self = this;
      self.$http.post(self.url.bankBranch, {
        Data: {
          BankId: self.formList[indexNum].form.Bank,
          CityId: self.formList[indexNum].form.City,
        }
      }).then(result => {
        for(var i in self.formTemplatenew[indexNum].formTpl){
          if(self.formTemplatenew[indexNum].formTpl[i].prop == 'AccountBank'){
            if (result.State == 1 && result.Data != null){
              self.formTemplatenew[indexNum].formTpl[i].options = result.Data;
            }else{
              self.formTemplatenew[indexNum].formTpl[i].options = [];
            }
          }
        }
      }, () => {
      });
    },




    onAccountChange(v) {
      let index = this.whichCom;
      var self = this;
      self.formChange.Account = true;
      if (v != null && v.length >= 6) {
        var s = v.substring(0, 6);
        self.$http.post(self.url.bankSearch, {
          Data: s
        }).then(result => {
          if (result.State == 1 && result.Data != null) {
            self.formList[index].form.Bank = result.Data.BankId;
            self.loadBankBranch();
          } else {
          }
        }, () => {
        });
      }

    },
    ContactsEmailChange(v){ // 联系人邮箱
      this.formChange.ContactsEmail = true;
    },
    BusinessLicenseChange(v){ // 营业执照
      let index = this.whichCom;
      this.formChange.BusinessLicense = true;
      if(this.formList[index].form.OnlyBusinessLicense) this.formList[index].form.DutyParagraph = this.formList[index].form.BusinessLicense;
    },
    JuridicalPersonChange(v){ // 法人
      this.formChange.JuridicalPerson = true;
    },
    DutyParagraphChange(v){ // 税号
      this.formChange.DutyParagraph = true;
    },
    PhoneChange(v){ // 电话
      this.formChange.Phone = true;
    },
    FaxChange(v){ // 传真
      this.formChange.Fax = true;
    },
    ZipCodeChange(v){ // 邮编
      this.formChange.Zip = true;
    },
  },
  created(){
    this.types = this.$route.query.types;
  },
  mounted() {
    this.loadBanks();
    this.loadProvince();
    this.loadData();
    // var json = localStorage.getItem('formBasic');
    // var obj = JSON.parse(json);
    // if(obj != null){
    //   this.formList[0].form.ContactsName = obj.ContactsName;
    //   this.formList[0].form.ContactsEmail = obj.ContactsEmail;
    //   this.formList[0].form.ContactCardId = obj.ContactCardNumber;
    // }

  },
  watch: {

  }
}



// WEBPACK FOOTER //
// ./src/views/Me/Company/Company.js